import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '',
  component: () =>
    import('modules/bpo/Index.vue'),
  children: [{
    path: '/manual-db/download',
    meta: {
      breadcrumbs: [{
        name: 'Dashboard',
        text: 'Home'
      },
      {
        text: 'SIGTIM',
        name: 'Sigtim'
      },
      {
        text: 'Manual de DB',
        name: 'ManualDeDb'
      }
      ]
    },
    name: 'ManualDeDb',
    component: () =>
      import('modules/bpo/ManualDeDb'),
    beforeEnter: (to, from, next) => {
      if (hasPermission('web.sigtim.manualdb.acesso')) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/manual-db',
    meta: {
      breadcrumbs: [{
        name: 'Dashboard',
        text: 'Home'
      },
      {
        text: 'SIGTIM',
        name: 'Sigtim'
      },
      ]
    },
    name: 'ImportManualDb',
    component: () =>
      import('modules/bpo/ImportManualDb'),
    beforeEnter: (to, from, next) => {
      if (hasPermission('web.sigtim.manualdb.acesso')) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/manual-db/importar',
    meta: {
      breadcrumbs: [{
        name: 'Dashboard',
        text: 'Home'
      },
      {
        text: 'SIGTIM',
        name: 'Sigtim'
      },
      ]
    },
    name: 'ImportManualDeDb',
    component: () =>
      import('modules/bpo/ImportManualDeDb'),
    beforeEnter: (to, from, next) => {
      if (hasPermission('web.sigtim.import.manualdb.import')) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/manual-db/historico',
    meta: {
      breadcrumbs: [{
        name: 'Dashboard',
        text: 'Home'
      },
      {
        text: 'SIGTIM',
        name: 'Sigtim'
      },
      ]
    },
    name: 'HistoryImportDb',
    component: () =>
      import('modules/bpo/HistoryImportDb'),
    beforeEnter: (to, from, next) => {
      if (hasPermission('web.sigtim.import.manualdb.history')) {
        next();
      } else {
        next('/');
      }
    }
  },
  ]
};